import { RMO } from '../components/RMO';
import { useConfigContext } from '../context/ConfigContext';
import { productName } from '../helpers/shared';
import { PageComponentWrapper } from './PageComponentWrapper';
import { useLocation } from 'react-router-dom';
import { BLOCK_TYPES } from '../interfaces/interfaces';

const RMOPage = () => {
    const config = useConfigContext();
    const location = useLocation();
    const { eventKey } = location.state;

    return (
        <div className={`page-wrapper`}>
            <div className="page-heading">{productName(config.product)}</div>
            <PageComponentWrapper wrapperChildren={<RMO eventKey={eventKey as BLOCK_TYPES} />} />
        </div>
    );
};

export default RMOPage;
